import { null as zNull } from "zod/v4";

export const disconnectMintsoftIntegration = {
  name: "disconnectMintsoftIntegration" as const,
  input: zNull(),
  output: zNull(),
};
